import apiClient, { USE_MOCK } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';
import { mockDnaData } from './mockDnaData';

// 根據 USE_MOCK 設定決定使用真實 API 或 Mock 資料
// 模擬網路延遲
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

/*
獲得題目、答案、結算結果
80 interact010 Member, Viewer
 */
export const get80DnaQuestion = async () => {
  if (USE_MOCK) {
  // if (1) {
    await delay(300);
    return {
      data: mockDnaData.i80Question,
    };
  }

  return apiClient.get(ENDPOINTS.DNA.i80_QUESTION);
};

/*
儲存受測者答案
81 interact011 Member, Viewer
"{
    ""record_id"": int,
    ""response"": {
        ""<question_id>"": <option_id>,
        ...
        }
}
record_id：此次作答紀錄的 ID
response：包含所有題目的作答對應
    <question_id>：題目 ID
    <option_id>：受測者選擇的選項 ID
response 需回傳所有題目的作答資料，以便系統能記錄受測者目前的作答進度。
格式也須按照 ""<question_id>"": <option_id>，因為這與後續的結果計算相關。"
 */
export const post81DnaSave = async (record_id, response) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockDnaData.i81Save,
    };
  }

  return apiClient.post(ENDPOINTS.DNA.i81_SAVE, { 
    record_id: Number(record_id),
    response,
  });
};

/*
計算測驗結果
82 interact012 Member, Viewer
{
        "record_id": int
}
 */
export const post82DnaCalculate = async (record_id) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockDnaData.i82Calculate,
    };
  }

  return apiClient.post(ENDPOINTS.DNA.i82_CALCULATE, { record_id }, { skipLang: true });
};

/*
開始新的測驗
83 interact013 Member, Viewer
 */
export const post83DnaRestart = async () => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockDnaData.i83Restart,
    };
  }
  return apiClient.get(ENDPOINTS.DNA.i83_RESTART);
}
/*
獲得測驗歷史紀錄
84 interact014 Member, Viewer
*/
export const get84DnaHistory = async () => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockDnaData.i84History,
    };
  }
  return apiClient.get(ENDPOINTS.DNA.i84_HISTORY);
}
//---------------------------------------------------------------------------
export default {
  get80DnaQuestion,
  post81DnaSave,
  post82DnaCalculate,
  post83DnaRestart,
  get84DnaHistory,
};
